// @TODO: abstract all games to share styles
/**
 * Ryan O'Dowd
 * 2022-03-22
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const NUM_INPUT_WIDTH = 52; // @TODO: too magic

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    verseText: {
      display: 'flex',
      paddingTop: globalScale * 8,
      paddingBottom: globalScale * 8,
      color: colors.white,
      fontSize: globalScale * 18,
    },
    optionsWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      flexDirection: 'row',
      paddingTop: 8,
      paddingBottom: 8,
    },
    option: {
      padding: globalScale * 8,
      borderRadius: globalScale * 12,
      margin: globalScale * 4,
      borderColor: colors.primaryExtraDark, // @TODO: okay in dark mode too?
      borderWidth: globalScale * 2,
    },
    selectedOption: {
      backgroundColor: colors.accent,
      borderColor: colors.accent,
    },
    correctOption: {
      backgroundColor: colors.accent,
      borderColor: colors.accent,
    },
    incorrectOption: {
      backgroundColor: colors.alert,
      borderColor: colors.alert,
    },
    optionText: { // @TODO: abstract with other games
      textAlign: 'center',
      color: colors.white,
      fontSize: globalScale * 16,
    },
    selectedOptionText: { // @TODO: abstract with other games
      textAlign: 'center',
      color: colors.primaryExtraDark,
      fontSize: globalScale * 16,
    },
    correctOptionText: { // @TODO: abstract with other games
      color: colors.primaryExtraDark,
    },
    incorrectOptionText: { // @TODO: abstract with other games
      color: colors.white,
    },

    customInputWrapper: {
      flex: 1,
      flexDirection: 'row',
    },
    customTextInput: {
      fontSize: globalScale * 20,
      margin: globalScale * 0,
      padding: globalScale * 8,
      paddingLeft: globalScale * 8,

      color: colors.accent,
      backgroundColor: 'transparent',
      width: '100%',
      height: 'auto',
    },
    autocompleteWrapper: {
      flex: 1,
      position: 'relative',
      backgroundColor: 'transparent',
    },
    autocompleteContainer: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 8,
      height: '100%',

      backgroundColor: 'transparent',
      borderColor: 'transparent',
      zIndex: 1,
      padding: 0,
      // @TODO: width: '100%',
    },
    autocompleteListContainerStyle: {
      minWidth: globalScale * 200, // @TODO: dynamic
      // @TODO:
      position: 'absolute',
      bottom: 0,
      left: Platform.OS === 'ios' ? 4 : 0,
    },
    numberInputContainer: {
      width: globalScale * NUM_INPUT_WIDTH,
      minWidth: globalScale * NUM_INPUT_WIDTH,
    },
    autocompleteContainerInner: {
      display: 'flex',
      borderWidth: globalScale * 2,
      borderRadius: globalScale * 12,
      borderColor: colors.accent,
      marginLeft: 0,
      marginRight: 0,
    },
    bookContainer: {
      display: 'flex',
      flexGrow: 1,
      minWidth: globalScale * 150,
      zIndex: 2,
    },
    chapterVerseContainer: {
      width: globalScale * NUM_INPUT_WIDTH,
      alignItems: 'center',
    },
    autocompleteOptionText: { // @TODO: update
      color: colors.white, // @TODO: light/dark mode pretty
      backgroundColor: colors.primaryDark, // @TODO: light/dark mode pretty
      // @TODO: minWidth: 200, // @TODO: dynamic
    },
    metaText: {
      fontSize: globalScale * 25,
      color: colors.accent,
      paddingLeft: 0,
    },
    incorrect: {
      color: colors.alert,
      borderColor: colors.alert,
    },
    correctReference: {
      display: 'flex',
      color: colors.accent,
      opacity: 1,
    },
    chapterAndVerse: { // @TODO: abstract with other games
      display: 'flex',
      paddingTop: globalScale * 8,
      paddingBottom: globalScale * 8,
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      opacity: 0.5, // @TODO: wish this were a bit darker because i like the look of this black with opacity: color: colors.primaryDark,
    },
  };
};

export default getStyles;
